<section class="debug--breakdown">
  <div class="col--right">
    @if (vm$ | async; as vm) {

      @if (vm.loading && showLoading) {
        <div class="grid">
          <div class="skeleton"></div>
          <div class="skeleton"></div>
          <div class="skeleton"></div>
          <div class="skeleton"></div>
        </div>

      } @else {

        @if (vm.isEmpty && showEmpty) {
          <app-empty-state></app-empty-state>

        } @else {

          @if (vm.donutCards.length) {
            <section class="breakdown-section">
              <div class="donut-grid">
                @for (c of vm.donutCards; track trackByFacet($index, c)) {
                  <app-multi-donut-card
                    [title]="c.title"
                    [series]="c.dataFlat"
                    [colors]="c.colors"
                    [showLegend]="true">
                  </app-multi-donut-card>
                }
              </div>
            </section>
          }

          @if (vm.barCards.length) {
            <section class="breakdown-section">
              <div class="bar-grid">
                @for (c of vm.barCards; track trackByFacet($index, c)) {
                  <app-bar-card
                    [title]="c.title"
                    [results]="c.data"
                    [legendData]="c.legendData">
                  </app-bar-card>
                }
              </div>
            </section>
          }

        }

      }

    } @else {

    }
  </div>
</section>
